export const valorMenosDescuento = ({valor, descuento}) =>{

    let descuentoValor = (valor * descuento) / 100

    return descuentoValor

}